import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f6168bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "call-to-action-text" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<p class=\"title up-fade\" data-v-2f6168bc>Os <b class=\"best-prices\" data-v-2f6168bc>melhores preços em FIFOs</b> pro seu negócio direto no WhatsApp</p><div style=\"height:18px;\" data-v-2f6168bc></div><p class=\"text-description up-fade\" style=\"animation-delay:.5s;\" data-v-2f6168bc>Os melhores preços pro seu negócio no atacado chegando pra você antes do seu concorrente receber. Compramos FIFOs direto da indústria e vendemos com muito desconto! Mas acaba rápido!</p><div style=\"height:32px;\" data-v-2f6168bc></div>", 4)
const _hoisted_6 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_6, [
      _createVNode($setup["CommonButton"], {
        onClick: _cache[0] || (_cache[0] = () => {
          $setup.WhatsAppInfra.sendMessage({
            phoneNumber: $setup.Constants.whatsappNumber,
            message: 'Olá, gostaria de falar com o representante comercial.',
          });
        }),
        type: "outlined"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Falar com representante comercial")
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}